"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = TextCard;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_native_1 = require("react-native");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const store_1 = require("../../store");
const document_1 = require("../../store/selectors/document");
const user_1 = require("../../slices/user");
const appState_1 = require("../../slices/appState");
const useDevice_1 = require("../../hooks/useDevice");
const useAppQuota_1 = require("../../hooks/useAppQuota");
const AppText_1 = require("../AppText");
const colors_1 = require("../../common/colors");
const spacing_1 = require("../../common/spacing");
const borders_1 = require("../../common/borders");
const constants_1 = require("../../common/constants");
const Linkable_1 = __importDefault(require("../ui-components/Linkable"));
const useDocument_1 = __importDefault(require("../../hooks/useDocument"));
const native_1 = require("@react-navigation/native");
function TextCard({ title, children, link }) {
    const { isMobileScreen } = (0, useDevice_1.useDevice)();
    const dispatch = (0, store_1.useAppDispatch)();
    const [isHovered, setIsHovered] = (0, react_1.useState)(false);
    const { params } = (0, native_1.useRoute)();
    const { hasPendingMessageQuota } = (0, useAppQuota_1.useAppQuota)();
    const documentJson = (0, react_redux_1.useSelector)(document_1.selectDocumentJson);
    const isDocumentTyping = (0, react_redux_1.useSelector)((state) => state.getUserOptions.IsCharacterTyping);
    const isChatImageLoading = (0, react_redux_1.useSelector)(document_1.selectIsImageLoading);
    const { startDocumentConversation } = (0, useDocument_1.default)();
    const isStreaming = (0, react_1.useMemo)(() => (!Boolean(params) || isDocumentTyping), [params, isDocumentTyping]);
    const handlePress = (0, react_1.useCallback)(() => {
        if (children) {
            if (hasPendingMessageQuota) {
                dispatch((0, user_1.setAutoSentMessage)(`Tell me briefly about in ${documentJson.language}:\n${children}`));
                startDocumentConversation({
                    documentJson,
                    shareId: params?.shareId
                });
            }
            else {
                dispatch((0, appState_1.setAppError)(constants_1.OUT_OF_QUOTA_MESSAGES));
            }
        }
    }, [
        children,
        documentJson,
        hasPendingMessageQuota,
        startDocumentConversation,
        params,
        dispatch,
    ]);
    const handleHoverIn = (0, react_1.useCallback)(() => {
        setIsHovered(true);
    }, []);
    const handleHoverOut = (0, react_1.useCallback)(() => {
        setIsHovered(false);
    }, []);
    return ((0, jsx_runtime_1.jsx)(Linkable_1.default, { href: link, children: (0, jsx_runtime_1.jsxs)(react_native_1.Pressable, { onHoverIn: !isStreaming ? handleHoverIn : undefined, onHoverOut: !isStreaming ? handleHoverOut : undefined, disabled: isStreaming || isChatImageLoading, onPress: isStreaming ? undefined : handlePress, style: ({ pressed }) => [
                styles.container,
                isMobileScreen && styles.containerMobile,
                !isStreaming && isHovered && styles.containerHovered,
                !isStreaming && pressed && styles.containerPressed
            ], children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.content, children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.title, children: title }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.description, children: children })] }), !isStreaming && ((0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faCircleArrowRight, style: [styles.linkIcon, isHovered && styles.linkIconHovered] }))] }) }));
}
const styles = react_native_1.StyleSheet.create({
    container: {
        backgroundColor: '#303032',
        width: 191,
        gap: spacing_1.Spacing.SPACING_MD,
        flexShrink: 0,
        padding: spacing_1.Spacing.SPACING_LG,
        borderColor: colors_1.Colors.DARK_500,
        borderWidth: 1,
        borderRadius: borders_1.Borders.RADIUS_2XL,
        flexDirection: 'row',
        alignItems: 'flex-start',
        flex: 1,
    },
    containerMobile: {
        width: 156,
    },
    containerHovered: {
        backgroundColor: `${colors_1.Colors.PRIMARY_300}35`,
    },
    containerPressed: {
        opacity: 0.8,
    },
    content: {
        flex: 1,
    },
    title: {
        color: 'white',
        fontSize: 16,
        fontWeight: '600',
        lineHeight: 20,
    },
    description: {
        color: colors_1.Colors.DARK_100,
        fontSize: 12,
        lineHeight: 16,
    },
    linkIcon: {
        color: 'white',
        fontSize: 16,
        opacity: 0,
    },
    linkIconHovered: {
        opacity: 1,
    }
});
